import { useState, useEffect } from "react";
import FloatingActionButtons from "../components/FloatingActionButton.tsx";
import NavBar from "../components/NavBar.tsx";
import { Outlet } from "react-router-dom";

// interface IRoot {
//   children?: any;
// }

export default function Root() {
  const [isSideMenu, setSideMenu] = useState(false);
  const [isFAB, setFAB] = useState(true);
  const scrollThreshold = 100;

  useEffect(() => {
    const handleScroll = () => {
      window.scrollY > scrollThreshold ? setFAB(false) : setFAB(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <div className=" bg-black/10 flex flex-col">
      <NavBar isVisible={isSideMenu} SetState={setSideMenu} />
      <div className="flex-1">
        <Outlet />
      </div>
      {isFAB && <FloatingActionButtons />}
    </div>
  );
}
